export class AddBuildingRangeToNewBuildingGroupDto {
  buildingIds: string[];
  surveyId: string;
  areaId: string;

  constructor(data: {
    buildingIds: string[];
    areaId: string;
    surveyId: string;
  }) {
    this.buildingIds = data.buildingIds;
    this.areaId = data.areaId;
    this.surveyId = data.surveyId;
  }
}
